module.exports = __webpack_public_path__ + "static/media/Dragger.438c257d.svg";